const loadYouTubeAPI = () => {
  if (document.getElementById('youtube-iframe-api')) return;
  const tag = document.createElement('script');
  tag.id = 'youtube-iframe-api';
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);
};

const extractVideoId = (iframe) => {
  const dataId = iframe.getAttribute('data-video-id');
  if (dataId) return dataId;

  const src = iframe.getAttribute('src') || '';
  // https://www.youtube.com/embed/{VIDEO_ID}
  const match = src.match(/youtube\.com\/embed\/([^?&]+)/);
  return match ? match[1] : null;
};

const init = () => {
  const youtubeWrappers = document.querySelectorAll('.js-youtubeWrapper');
  if (youtubeWrappers.length === 0) return;

  loadYouTubeAPI();

  window.onYouTubeIframeAPIReady = () => {
    youtubeWrappers.forEach((wrapper) => {
      const playButton = wrapper.querySelector('.js-youtubePlayButton');
      const iframe = wrapper.querySelector('.js-youtubePlayerFrame');

      if (!playButton || !iframe) return;

      const videoId = extractVideoId(iframe);
      if (!videoId) {
        console.warn('[YouTube] Video ID が取得できませんでした:', iframe);
        return;
      }
      const player = new YT.Player(iframe, {
        videoId,
        events: {
          onStateChange: (event) => {
            const isPlaying = event.data === YT.PlayerState.PLAYING;
          },
        },
      });

      playButton.addEventListener('click', (e) => {
        e.preventDefault();
        wrapper.classList.add('is-playing');
        player.playVideo();
      });
    });
  };
};

export { init };